import { render, staticRenderFns } from "./notes.vue?vue&type=template&id=1f6126f0&scoped=true&"
import script from "./notes.vue?vue&type=script&lang=js&"
export * from "./notes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6126f0",
  null
  
)

export default component.exports